import Svg, { Path } from 'react-native-svg';
import type { TLabelSymbolProps } from '../../../types/softwareLabelTypes';

export const ManufacturerSymbol = ({
  width = 28,
  height = 26,
}: TLabelSymbolProps) => (
  <Svg width={width} height={height} viewBox="28 34 144 132">
    <Path d="m28.814 118.25 21.553-37.331 16.605 28.761 16.605-28.761 16.605 28.761 16.605-28.761 16.687 28.903v-75.713h37.712v131.78h-142.37z" />
  </Svg>
);
